module.exports = __webpack_public_path__ + "img/round-developer_board-24px.a3f7d77c.svg";